import React from 'react';
import { PDFViewer } from '@react-pdf/renderer';
import { InvoiceClassicDocument } from '../../blocks/pdfx/invoice-classic/invoice-classic';

const PdfDemoPage: React.FC = () => {
    // Mock data based on a real Cresta scenario
    const mockInvoiceData = {
        invoiceNumber: 'FAC-2026-0042',
        invoiceDate: new Date().toLocaleDateString('es-CO', { day: 'numeric', month: 'long', year: 'numeric' }),
        dueDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toLocaleDateString('es-CO', { day: 'numeric', month: 'long', year: 'numeric' }),
        companyName: 'Cresta SaaS',
        subtitle: 'Plataforma para Salones de Belleza',
        companyAddress: 'Medellín, Colombia',
        companyEmail: 'hola@cr3sta.com',
        billTo: {
            name: 'Salón Bloom Medellín',
            address: 'Cl. 10 #43e-21, El Poblado',
            email: 'contacto@salonbloom.co',
            phone: '+57 300 123 4567',
        },
        items: [
            { description: 'Suscripción Mensual - Plan Cresta Pro', quantity: 1, unitPrice: 49900 },
        ],
        summary: {
            subtotal: 49900,
            tax: 0, // Simplified for demo
            total: 49900,
        },
        paymentTerms: {
            dueDate: '30 días',
            method: 'Wompi / PSE / Tarjeta',
            gst: 'NIT 901234567-8',
        },
        notes: 'Gracias por confiar en Cresta para el crecimiento de tu negocio.',
        logo: '/logo-full.png' // Adjust to existing logo path
    };

    return (
        <div className="flex flex-col h-[calc(100vh-100px)] p-6 animate-fade-in">
            <div className="mb-6">
                <h1 className="text-3xl font-bold text-white bg-clip-text text-transparent bg-gradient-to-r from-teal-400 to-indigo-500">
                    Previsualización de Factura
                </h1>
                <p className="text-gray-400 mt-2">
                    Esta es una demostración de cómo se generan los PDFs profesionales usando los nuevos componentes PDFx.
                </p>
            </div>

            <div className="flex-1 rounded-2xl overflow-hidden border border-white/10 glass-card">
                <PDFViewer width="100%" height="100%" showToolbar={true} className="border-none">
                    <InvoiceClassicDocument data={mockInvoiceData as any} />
                </PDFViewer>
            </div>
            
            <div className="mt-4 text-center">
                <p className="text-xs text-gray-500">
                    Tip: Puedes descargar o imprimir el archivo directamente desde el visor superior.
                </p>
            </div>
        </div>
    );
};

export default PdfDemoPage;
